<template>
  <div>
    <loading :active.sync="isLoading" :is-full-page="fullPage" :loader="$store.state.spinerLoader"
      :color="$store.state.spinerColor"></loading>
    <b-card class="mt-4">
      <b-row align-v="center" slot="header">
        <b-col cols="8">
          <h3 class="mb-0">
            <b-button size="md" class="mr-2" @click="redirectToHome" variant="outline-primary"><i
                class="fa-solid fa-house-chimney"></i></b-button>
            Home
          </h3>
        </b-col>
      </b-row>

      <b-row>
        <b-col lg="4">
          <div class="form-group">
            <label class="form-control-label">Choose a Client</label>
            <v-select class="vue-select" placeholder="Choose a Client" :options="userClientOptions" label="name"
              v-model="client" :reduce="(option) => option.id" v-on:input="filterClaimListByClient"></v-select>
          </div>
        </b-col>

        <b-col lg="2">
          <div class="form-group">
            <label class="form-control-label">FYE</label>
            <v-select ref="fyeDropdown" class="vue-select" placeholder="Choose Year" :options="fyeOptions" label="name" v-model="fye"
              v-on:input="filterClaimListByFye"></v-select>
          </div>
        </b-col>

        <!-- <b-col lg="4">
          <div class="pt-2 mt-4">
            <b-input-group>
              <b-form-input
                class="search-outline"
                placeholder="Quick search Clients & Claims"
              ></b-form-input>
              <b-input-group-append>
                <b-button
                  @click="redirectToClaimWizard"
                  variant="outline-secondary"
                  ><i class="fa-solid fa-magnifying-glass"></i
                ></b-button>
              </b-input-group-append>
            </b-input-group>
          </div>
        </b-col> -->
      </b-row>
    </b-card>

    <b-card class="mt-4" v-if="is_reviewer || is_admin">
      <b-row>
        <b-col lg="12">
          <b-button v-if="is_reviewer" @click="reviewPage" variant="outline-primary" class="btn-design">
            Review
          </b-button>
          <b-button v-if="is_admin" @click="reviewWorkflow" variant="outline-primary" class="btn-design">
            Review workflow
          </b-button>
        </b-col>
      </b-row>
    </b-card>

    <b-row>
      <b-col lg="6">
        <card class="mt-3 mb-3">
          <b-row align-v="center" class="pin-claim">
            <b-col cols="5">
              <h3 class="mb-0">Claims</h3>
            </b-col>

            <b-col cols="7">
              
              <div class="form-inline float-right">
                Pinned
                <b-checkbox class="ml-1" id="checkboxf-1" name="checkboxf-1" size="sm" value="PINNED"
                  v-model="filterType" @change="filterClaimTable('PINNED')">
                </b-checkbox>
                All
                <b-checkbox class="ml-1" id="checkboxf-2" name="checkboxf-2" size="sm" value="ALL" v-model="filterType"
                  @change="filterClaimTable('ALL')">
                </b-checkbox>

                Assigned
                <b-checkbox class="ml-1" id="checkboxf-3" name="checkboxf-3" size="sm" value="ASSIGNED"
                  v-model="filterType" @change="filterClaimTable('ASSIGNED')">
                </b-checkbox>
              </div>
            </b-col>
          </b-row>
          <b-row class="mb-3">
             <b-col cols="12">
                <div class="">
                  <b-input-group>
                    <b-form-input
                      class="search-outline"
                      placeholder="Search"
                      v-model="globalClaimFilterStr"
                    ></b-form-input>
                    <b-input-group-append>
                      <b-button
                        @click="clearGlobalClaimSearchString"
                        variant="outline-secondary"
                        ><i class="fa-solid fa-times"></i
                      ></b-button>
                      <b-button
                        @click="startGlobalClaimSearchString"
                        variant="outline-secondary"
                        ><i class="fa-solid fa-magnifying-glass"></i
                      ></b-button>
                    </b-input-group-append>
                  </b-input-group>
                </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <vuetable ref="vuetable" :api-mode="false" :fields="fields" :per-page="perPage"
                :data-manager="dataManager" pagination-path="pagination" @vuetable:pagination-data="onPaginationData">
                <template slot="description" scope="props">
                  <span class="custom-non-br-undeline">
                    <b-link @click="rowClicked(props.rowData)" href="#">{{
                      claimFyeStr(props.rowData) +
                      " | " +
                      claimTypeStr(props.rowData)
                    }}</b-link>
                  </span>
                </template>
              </vuetable>
            </b-col>
            <b-col cols="12" class="pt-2">
              <vuetable-pagination-info ref="paginationInfo"></vuetable-pagination-info>

              <vuetable-pagination class="float-right" ref="pagination"
                @vuetable-pagination:change-page="onChangePage">
              </vuetable-pagination>

              <div class="custom-pagination-buttons">
                <b-button @click="goToFirstPage" :disabled="!canGoToFirstPage" variant="outline-primary" class="btn-design">
                  First
                </b-button>
                <b-button @click="goToLastPage" :disabled="!canGoToLastPage" variant="outline-primary" class="btn-design">
                  Last
                </b-button>
              </div>
            </b-col>
          </b-row>
        </card>
      </b-col>

      <b-col lg="6">
        <card class="mt-3 mb-3">
          <b-row align-v="center" class="notification-color">
            <b-col cols="8">
              <h3 class="mb-0 text-white">Notifications All Claims</h3>
            </b-col>
          </b-row>

          <b-row>
            <b-col cols="12">
              <vuetable ref="vuetableNotifications" :api-mode="false" :fields="notificationfield" :per-page="perPage"
                :data-manager="dataManagerNotifications" pagination-path="pagination"
                @vuetable:pagination-data="onPaginationDataNotification">
                <template slot="custom-description" scope="props">
                  <span v-html="truncateText(props.rowData.description)"></span>
                  <a v-if="props.rowData.description.length > 60"
                    @click="setActiveDescriotion(props.rowData.description)" class="a-style"
                    v-b-modal.modal-notification>
                    View More</a>
                </template>
              </vuetable>
            </b-col>
            <b-col cols="12" class="pt-2">
              <vuetable-pagination-info ref="paginationInfoNotification"></vuetable-pagination-info>
              <vuetable-pagination class="float-right" ref="paginationNotification"
                @vuetable-pagination:change-page="onChangePageNotifications"></vuetable-pagination>
            </b-col>
          </b-row>
        </card>
      </b-col>
    </b-row>

    <!-- Start Notification Modal -->
    <b-modal id="modal-notification" hide-footer>
      <template #modal-title>
        <h3>Notification</h3>
      </template>
      <div class="d-block">
        <b-row>
          <b-col cols="12">
            <p v-html="activeNotification"></p>
          </b-col>
        </b-row>
      </div>

      <div class="float-right mt-5">
        <b-button variant="" @click="$bvModal.hide('modal-notification')">Cancel</b-button>
      </div>
    </b-modal>
    <!-- End Notification Modal -->
  </div>
</template>

<script>
import Vuetable from "vuetable-2/src/components/Vuetable";
import VuetablePagination from "../Vuetable/VuetablePaginationBootstrap4";
import VuetablePaginationInfo from "vuetable-2/src/components/VuetablePaginationInfo.vue";
import FieldsDef from "./PinnedClaimDef.js";
import ClaimNotificationDef from "./ClaimNotificationDef.js";
import "vue-select/dist/vue-select.css";
import { mapActions, mapState } from "vuex";
import mixins from "./../../mixins/common.js";
import _ from "lodash";
import router from "@/routes/router";

// import msal from '@azure/msal-browser';

export default {
  components: {
    Vuetable,
    VuetablePagination,
    VuetablePaginationInfo,
  },
  mixins: [mixins],
  data() {
    return {
      fields: FieldsDef,
      notificationfield: ClaimNotificationDef,
      userClientOptions: [],
      isLoading: false,
      fullPage: true,
      claimdata: [],
      notificationData: [],
      perPage: 10,
      sortOrder: [],
      sortOrderNotification: [],
      activeNotification: "",
      filterType: "PINNED",
      fye: "",
      fyeOptions: [],
      globalClaimFilterStr: "",
      paginationInfoClaimsTable: null
    };
  },
  watch: {
    claimdata(newVal, oldVal) {
      this.$refs.vuetable.refresh();
    },
    notificationData(newVal, oldVal) {
      this.$refs.vuetableNotifications.refresh();
    },
  },
  methods: {
    ...mapActions("admin", [
      "getUserClients",
      "getClientsClaims",
      "getAllPinnedClaims",
      "getAllClaimsNotifications",
      "getFilteredClaims",
      "getFicicalYearDropdown",
      "clientsFilterByFye",
    ]),
    goToFirstPage() {
      this.onChangePage(1);
    },
    goToLastPage() {
      this.onChangePage(this.totalPages);
    },
    clearGlobalClaimSearchString(){
      this.globalClaimFilterStr = "";
      this.$refs.vuetable.refresh();
    },
    startGlobalClaimSearchString(){
      this.$refs.vuetable.refresh();
    },
    getFicicalOptions() {
      let dataParams = {};
      this.getFicicalYearDropdown(dataParams).then((data) => {
        if (data.data.errors) {
        } else {
          let filtered = _.sortBy(data.data, function (fiscalYear) {
            return fiscalYear;
          });
          let sortedClaimArray = filtered.reverse();

          this.fyeOptions = sortedClaimArray;
        }
      });
    },
    reviewWorkflow(){
      router.push({
        name: "reviewWorkflowPage"
      });
    },
    async reviewPage() {
      router.push({
        name: "reviewpage"
      });
    },
    filterClaimTable(type) {
      this.isLoading = true;
      let dataParams = {
        Filter: type,
      };
      this.getFilteredClaims(dataParams).then((data) => {
        if (data.data.errors) {
        } else {
          this.claimdata = data.data;
        }
        this.isLoading = false;
      });
    },
    setActiveDescriotion(activeNotification) {
      this.activeNotification = activeNotification;
    },
    rowClicked(data) {
      let rowdata = data;
      this.client = rowdata.client.id;
      this.claim = rowdata.id;
      this.activeClaim = rowdata;
      let filtered = this.userClientOptions.filter((client) => {
        return client.id == this.client;
      });
      if (filtered[0]) {
        this.client_name = filtered[0].name;
      }
      router.push({
        name: "claimwizard",
        query: { claim_id: this.claim, client_id: this.client },
      });
    },
    onPaginationData(paginationData) {
      this.$refs.pagination.setPaginationData(paginationData);
      this.$refs.paginationInfo.setPaginationData(paginationData);

      this.paginationInfoClaimsTable = paginationData;
    },
    onPaginationDataNotification(paginationData) {
      this.$refs.paginationNotification.setPaginationData(paginationData);
      this.$refs.paginationInfoNotification.setPaginationData(paginationData);
    },

    onChangePage(page) {
      this.$refs.vuetable.changePage(page);
    },
    onChangePageNotifications(page) {
      this.$refs.vuetableNotifications.changePage(page);
    },
    filterClaimListByClient() {
      if (this.client) {
        let filtered = this.userClientOptions.filter((client) => {
          return client.id == this.client;
        });
        if (filtered[0]) {
          this.client_name = filtered[0].name;
        }

        router.push({
          name: "claimwizard",
          query: { client_id: this.client },
        });
      }
    },

    filterClaimListByFye() {
      this.$nextTick(() => {
        const inputElement = this.$refs.fyeDropdown.$el.querySelector('input');
        if (inputElement) {
          inputElement.blur();
        }
      });

      if(this.fye){
          let dataParams = {
          Fye: this.fye,
        };
        this.clientsFilterByFye(dataParams).then((data) => {
          if (data.data.errors) {
          } else {
            this.userClientOptions = data.data;
          }
        });
      }else{
        const userdata = {
          user_id: this.user_id,
        };

        this.getUserClients(userdata).then((data) => {
          if (data.data.errors) {
        } else {
          this.userClientOptions = data.data;
        }
    });
      }
    },
    dataManagerNotifications(sortOrder, pagination) {
      let local = this.notificationData;

      /* loadash filter array from id */
      let filtered = _.sortBy(this.notificationData, function (obj) {
        return obj.id;
      });
      local = filtered.reverse();
     
      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      pagination = this.$refs.vuetableNotifications.makePagination(
        local.length,
        this.perPage
      );
      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },
    dataManager(sortOrder, pagination) {
      let local = this.claimdata;
      var self = this;
      if (this.globalClaimFilterStr) {
        let txt = new RegExp(this.globalClaimFilterStr, "i");
        let dataFil = _.filter(local, function (item) {
          return  item.client.name.search(txt) >= 0
            || self.claimFyeStr(item).search(txt) >= 0
            || self.claimTypeStr(item).search(txt) >= 0
        });
        local = dataFil;
      }
      
      pagination = this.$refs.vuetable.makePagination(
        local.length,
        this.perPage
      );

      // sortOrder can be empty, so we have to check for that as well
      if (sortOrder.length > 0) {
        local = _.orderBy(
          local,
          sortOrder[0].sortField,
          sortOrder[0].direction
        );
      }

      let from = pagination.from - 1;
      let to = from + this.perPage;
      return {
        pagination: pagination,
        data: _.slice(local, from, to),
      };
    },
  },
  mounted() {
    //clear snotofy
    this.clearSnotifyMessages();
    const userdata = {
      user_id: this.user_id,
    };
    this.getUserClients(userdata).then((data) => {
      if (data.data.errors) {
      } else {
        this.userClientOptions = data.data;
      }
    });
    this.getAllClaimsNotifications().then((data) => {
      if (data.data.errors) {
      } else {
        this.notificationData = data.data.data;
      }
    });
    this.filterClaimTable("PINNED");
    this.getFicicalOptions();


    if (window.location.href && window.location.href.split('?').length > 1) {
      const urlParams = new URLSearchParams(window.location.href.split('?')[1].split('#')[0]);
        var code = urlParams.get('code');

        router.push({
          name: "reviewpage",
          params: { code: code }
        });
    }
  },
  computed: {
    ...mapState("user", ["user_id", "is_reviewer", "is_admin"]),
    activeClaim: {
      get() {
        return this.$store.state.activeClaim;
      },
      set(val) {
        this.$store.state.activeClaim = val;
      },
    },
    totalPages() {
    return this.paginationInfoClaimsTable.total && this.paginationInfoClaimsTable.per_page
      ? Math.ceil(this.paginationInfoClaimsTable.total / this.paginationInfoClaimsTable.per_page)
      : 0;
  },
    canGoToFirstPage() {
      return this.paginationInfoClaimsTable && this.paginationInfoClaimsTable.current_page > 1;
    },
    canGoToLastPage() {
      return this.paginationInfoClaimsTable && this.paginationInfoClaimsTable.current_page < this.totalPages;
    },
    client: {
      get() {
        return this.$store.state.client;
      },
      set(val) {
        this.$store.state.client = val;
      },
    },
    claim: {
      get() {
        return this.$store.state.claim;
      },
      set(val) {
        this.$store.state.claim = val;
      },
    },
    client_name: {
      get() {
        return this.$store.state.client_name;
      },
      set(val) {
        this.$store.state.client_name = val;
      },
    },
  },
};
</script>

<style scoped>
.custom-non-br-undeline {
  border-bottom: 1px;
  border-bottom-style: solid;
}

/* .content-height{
    min-height: 85vh;
} */

.pin-claim {
  background-color: #dee0ca;
  padding: 10px;
  margin-top: -21px;
  margin-bottom: 10px;
  margin-left: -21px;
  margin-right: -21px;
}

.notification-color {
  background-color: #921210;
  padding: 10px;
  margin-top: -21px;
  margin-bottom: 10px;
  margin-left: -21px;
  margin-right: -21px;
  border-radius: 4px 4px 0px 0px;
}
</style>
